var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0289 10.8183L5.25464 6.04407L10.0289 6.04407V10.8183Z",
    fill: "#555555",
    stroke: "#555555",
    strokeWidth: 0.901555
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.925967,
    y: 0.540225,
    width: 10.9807,
    height: 7.85577,
    rx: 0.802938,
    fill: "#555555",
    stroke: "white",
    strokeWidth: 0.477423
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponses);
export default __webpack_public_path__ + "static/media/responses.fb161f1dd5b4e28034ecfc235468b22f.svg";
export { ForwardRef as ReactComponent };